import { memo, useEffect } from 'react';

import { logWarn } from '@/shared/lib/logging';

export const CookieConsent = memo(() => {
    useEffect(() => {
        // Create and inject the configuration script
        const configScript = document.createElement('script');

        configScript.id = 'iubenda-config';
        configScript.innerHTML = `
            var _iub = _iub || [];
            _iub.csConfiguration = {
                "siteId":4069153,
                "cookiePolicyId":18144304,
                "storage":{"useSiteId":true},
                "googleConsentMode":"template",
                "callback": {
                    "onReady": function() {
                        const fixIubendaZIndex = () => {
                            const iubendaButtons = document.querySelectorAll('.iubenda-tp-btn, .iubenda-cs-preferences-link');
                            iubendaButtons.forEach(button => {
                                button.style.setProperty('z-index', '3', 'important');
                            });
                        };

                        fixIubendaZIndex();
                    }
                }
            };
            _iub.csLangConfiguration = {"en-GB":{"cookiePolicyId":18144304},"it":{"cookiePolicyId":42037650}};
        `;
        document.head.appendChild(configScript);

        // Array of scripts to load
        const scriptsToLoad = [
            'https://cs.iubenda.com/autoblocking/4069153.js',
            '//cdn.iubenda.com/cs/tcf/stub-v2.js',
            '//cdn.iubenda.com/cs/tcf/safe-tcf-v2.js',
            '//cdn.iubenda.com/cs/gpp/stub.js',
        ];

        const scriptElements: HTMLScriptElement[] = [];

        // Load synchronous scripts first
        scriptsToLoad.forEach((src) => {
            const script = document.createElement('script');

            script.src = src;
            document.head.appendChild(script);
            scriptElements.push(script);
        });

        // Load the async script last
        const asyncScript = document.createElement('script');

        asyncScript.src = '//cdn.iubenda.com/cs/iubenda_cs.js';
        asyncScript.async = true;
        document.head.appendChild(asyncScript);
        scriptElements.push(asyncScript);

        // Cleanup function
        return () => {
            // Remove config script
            const existingConfigScript =
                document.getElementById('iubenda-config');

            if (existingConfigScript) {
                existingConfigScript.remove();
            }

            // Remove all loaded scripts
            scriptElements.forEach((script) => {
                if (script && script.parentNode === document.head) {
                    try {
                        document.head.removeChild(script);
                    } catch (err) {
                        logWarn('Failed to remove Iubenda script:', err);
                    }
                }
            });
        };
    }, []);

    return null;
});

CookieConsent.displayName = 'CookieConsent';
